import React, { useState, useEffect, useRef } from 'react';

import { UserCommissionRepository } from '../../MedicareProAPI/Repositories/User/UserCommissionRepository';
import { PlanRepository } from '../../MedicareProAPI/Repositories/PlanRepository';
import { IndPolicyRepository } from '../../MedicareProAPI/Repositories/Ind/IndPolicyRepository';
import CommissionSingle from '../Components/CommissionSingle';
import { SchedulesContext } from '../Context/SchedulesContext';

export default function CommissionsPanel(props) {
  console.log('selectedType', props?.selectedCommissionType);
  const [commissionTypes, setCommissionTypes] = useState(null);
  const [commissionPolicyGroups, setCommissionPolicyGroups] = useState(null);
  const [selectedCommissionType, setSelectedCommissionType] = useState(null);
  const [schedulesByPlanId, setSchedulesByPlanId] = useState({});
  const [noPlanTypes, setNoPlanTypes] = useState(false);

  const userCommissionRepository = new UserCommissionRepository();
  userCommissionRepository.setAccessToken(props.userAccessToken);

  //The 'individualPolicyRepository' object construction makes the dependencies of useEffect Hook (at line 54) change on every render.
  const individualPolicyRepositoryRef = useRef(new IndPolicyRepository());
  const planRepositoryRef = useRef(new PlanRepository());

  const updateSchedules = (policyId, schedules) => {
    setSchedulesByPlanId((prev) => ({
      ...prev,
      [policyId]: schedules,
    }));
  };

  useEffect(() => {
    planRepositoryRef.current.setAccessToken(props.userAccessToken);
    individualPolicyRepositoryRef.current.setAccessToken(props.userAccessToken);
  }, [props.userAccessToken]);

  // Fetch user plan types on mount
  useEffect(() => {
    planRepositoryRef.current.getUserPlanTypes(props.userId).then((commissionTypes) => {
      setCommissionTypes(commissionTypes);

      if (
        Array.isArray(commissionTypes) &&
        commissionTypes.length > 0 &&
        commissionTypes[0]?.name
      ) {
        setSelectedCommissionType(props?.selectedCommissionType || commissionTypes[0].name);
      }

      if (commissionTypes.length === 0) {
        setNoPlanTypes(true);
      }
    });
  }, [props.userId]);

  // Fetch user policies based on selected commission type
  useEffect(() => {
    if (selectedCommissionType) {
      individualPolicyRepositoryRef.current
        .getUserPolicies(props.userId, selectedCommissionType, {
          include: ['company', 'plan'],
          limit: 1000,
        })
        .then((policies) => {
          const cardGroups = [];

          policies.getItems().forEach((policy) => {
            const companyName = policy.getCompany().getCompanyName();
            let group = cardGroups.find((g) => g.name === companyName);

            if (!group) {
              group = { name: companyName, policies: [] };
              cardGroups.push(group);
            }

            group.policies.push(policy);
          });

          setCommissionPolicyGroups(cardGroups);
        });
    }
  }, [props.userId, selectedCommissionType]);

  return (
    <div className="row contactCard">
      <div className="col-12  px-2  sm-resp">
        <div
          className="card cardAddress"
          style={{ ...{ height: 'auto' }, ...(props.cardStyle || {}) }}
        >
          <div className="card-header mb-0">
            <span className="proCrdTitleFull">{!props.showHeader ? '' : 'Commissions'}</span>
          </div>

          <div className="card-body" id="rxCards">
            {(!commissionTypes || !commissionPolicyGroups) && !noPlanTypes && (
              <div className="alert small alert-info" role="alert">
                <i className="fas fa-spinner fa-spin ml-2"></i> Loading....
              </div>
            )}
            {noPlanTypes && (
              <div className="alert small alert-warning" role="alert">
                <i className="fas fa-exclamation-circle mr-2"></i>Your database does not contain any
                non-CMS policies (such as Med Supp or ancillary products). Therefore, no schedules
                can be created.
              </div>
            )}
            {commissionTypes && commissionPolicyGroups && (
              <>
                <div className="alert alert-secondary mb-4">
                  <i className="fal fa-comment-exclamation mr-2"></i> Below is a list of non-CMS
                  policies that are active or pending within your database. For more accurate
                  commission data, enter your commission schedule for each plan type.
                  {props.isEmbedded && (
                    <>
                      <br></br>
                      You can also access this panel from{' '}
                      <a href="https://www.medicareproapp.com/agent/settings/commissions">
                        settings
                      </a>
                    </>
                  )}
                </div>
                <div className="settingsNavSub pb-3">
                  {commissionTypes &&
                    commissionTypes.map((planType) => (
                      <div
                        key={planType.name}
                        className={
                          (planType.name === selectedCommissionType ? 'setSelSub ' : '') +
                          'btn btn-sm mr-0 mb-3'
                        }
                        onClick={() => {
                          setSelectedCommissionType(planType.name);
                        }}
                      >
                        {planType.label}
                      </div>
                    ))}
                </div>
                <div className="plan-list pb-3">
                  {commissionPolicyGroups &&
                    commissionPolicyGroups.map((cardGroup) => (
                      <SchedulesContext.Provider
                        value={{ schedulesByPlanId, updateSchedules }}
                        key={cardGroup.name}
                      >
                        <div className="row mb-3">
                          <div className="col-12 font-weight-bold">
                            <div className="badge badge-info mt-3" style={{ fontSize: '10pt' }}>
                              {cardGroup.name}
                            </div>
                          </div>
                        </div>

                        {cardGroup.policies.map((policy) => (
                          <CommissionSingle
                            key={policy.getPolicyId()}
                            policy={policy}
                            policyGroup={cardGroup}
                            userId={props.userId}
                            userAccessToken={props.userAccessToken}
                            dispatchOnUpsert={props.dispatchOnUpsert}
                            onSave={props.onSave}
                          />
                        ))}
                      </SchedulesContext.Provider>
                    ))}
                </div>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
